import React from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { ProblemSection } from './components/ProblemSection';
import { WhoIsItFor } from './components/WhoIsItFor';
import { ContentPreview } from './components/ContentPreview';
import { Curriculum } from './components/Curriculum';
import { Bonuses } from './components/Bonuses';
import { OfferStack } from './components/OfferStack';
import { Testimonials } from './components/Testimonials';
import { AboutAuthor } from './components/AboutAuthor';
import { BackedBy } from './components/BackedBy';
import { Guarantee } from './components/Guarantee';
import { Format } from './components/Format';
import { FAQ } from './components/FAQ';
import { BeforeAfter } from './components/BeforeAfter';
import { FinalOffer } from './components/FinalOffer';
import { FinalCTA } from './components/FinalCTA';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { StickyBuyBar } from './components/StickyBuyBar';
import { PurchaseNotifications } from './components/PurchaseNotifications';
export function App() {
  return <div className="min-h-full w-full bg-ink-950 pb-20 font-sans text-white lg:pb-0" data-id="element-0" data-mp="3mjzsl4a6121a">
      <main data-id="element-1" data-mp="3rdatypw7kqlt">
        <Hero data-id="element-2" data-mp="3rcsw5otwe4bs" />
        <StatsBar data-id="element-3" data-mp="3recf5n6xuth9" />
        <ProblemSection data-id="element-4" data-mp="5yjetptzbev" />
        <WhoIsItFor data-id="element-5" data-mp="6htjo98ovic" />
        <ContentPreview data-id="element-6" data-mp="4n53zyrel9i" />
        <Curriculum data-id="element-7" data-mp="56qxrrj5tst" />
        <Bonuses data-id="element-8" data-mp="2zl3alhpbj03q" />
        <OfferStack data-id="element-9" data-mp="2zlle8zeb8glo" />
        <Testimonials data-id="element-10" data-mp="2zm4wyibsb90r" />
        <AboutAuthor data-id="element-11" data-mp="2zmwif0bo3qdb" />
        <BackedBy data-id="element-12" data-mp="2zng32ospcsv1" />
        <Guarantee data-id="element-13" data-mp="33mf1rrnubte1" />
        <Format data-id="element-14" data-mp="33lx0ggmbmoz9" />
        <FAQ data-id="element-15" data-mp="33ngfk3w8qtzg" />
        <BeforeAfter data-id="element-16" data-mp="33mymth8sexwa" />
        <FinalOffer data-id="element-17" data-mp="33oi0r16z0wuw" />
        <FinalCTA data-id="element-18" data-mp="38m1iwc6shts4" />
        <Contact data-id="element-19" data-mp="38kqcs5pvg9xu" />
      </main>
      <Footer data-id="element-20" data-mp="38kgkgbhctqoz" />
      <StickyBuyBar data-id="element-21" data-mp="38num1hi71vvd" />
      <PurchaseNotifications data-id="element-22" data-mp="3dkl4gbhh13jy" />
    </div>;
}